import BaseModel from '../core/BaseModel';

export default class VoucherModel extends BaseModel {

    constructor() {
        super({
                name: "voucher",
                tableName: 'voucher',
                label: "Voucher",
                display_key: 'code'  
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                code: {
                    name: 'code',
                    type: "String",
                    label: 'Code',
                    width: 20,
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                },
                short_description: {
                    name: 'short_description',
                    type: "String",
                    label: 'short_description',
                    width: 20,
                    class: 'left',
                    display : false,
                },
                type_condition: {
                    name: 'type_condition',
                    type: "Selection",
                    label: 'Type',
                    options: [
                        { value: 1, label: 'All services' },
                        { value: 2, label: 'Rent' },
                        { value: 3, label: 'Buy' }
                    ],
                    filter: { type: 'select', match: 'equals',   optionLabel: 'label', optionKey: 'value', },
                    width: 15,
                    class: 'left',
                },
                
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Title',
                    width: 20,
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                },
                amount: {
                    name: 'amount',
                    type: "Number",
                    label: 'Discount',
                    width: 10,
                    class: 'left',
                },
                valid_start: {
                    name: 'valid_start',
                    type: "Custom",
                    label: 'Start',
                    width: 10,
                    class: 'left',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                valid_end: {
                    name: 'valid_end',
                    type: "Custom",
                    label: 'End',
                    width: 10,
                    class: 'left',
                    filter: { type: 'DateRange', match: 'equals' }
                },
                duration: {
                    name: 'duration',
                    type: "Number",
                    label: 'Duration',
                    display: false
                },
                valid_duration: {
                    name: 'valid_duration',
                    type: "Number",
                    label: 'Valid Duration',
                    display: false
                },
                type_discount: {
                    name: 'type_discount',
                    type: "Number",
                    label: 'Type Discount',
                    display: false
                },
                max_discount_amount: {
                    name: 'max_discount_amount',
                    type: "Number",
                    label: 'Max Discount Amount',
                    display: false
                },
                type_apply_customer: {
                    name: 'type_apply_customer',
                    type: "Number",
                    label: 'Type Apply Customer',
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    label: 'Created At',
                    display: false
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    display: false
                },
                created_by: {
                    name: 'created_by',
                    type: "Uuid",
                    label: 'Created By',
                    display: false
                },
                // used
                used_key: {
                    name: "used",
                    type: "Number",
                    label: "Used",
                    width: 10,
                    class: "left",
                    computed: (data) => {
                        data.used_key = '';
                    },
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        { value: 'true', label: 'Yes', style: 'color:  #000000;' },
                        { value: 'false', label: 'No', style: 'color:  #000000;' }
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: "left",
                    width: 8,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    computed: (data) => {
                        data.updated_by_key = '';
                    },
                    class: "left",
                    width: 8,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Custom",
                    label: 'Updated date',
                    width: 8,
                    class: "left",
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Deleted",
                    display: false
                },
                limit_use: {
                    name: "limit_use",
                    type: "Boolean",
                    label: "Limit Use",
                    display: false
                },
                
                detail_get: {
                    refs:  ' obj_update_by  { id fullname }  ',
                    display: false
                },
            })
    }
}
